import BaseLayer from "./BaseLayer";
import {plotDisagreementsHelper} from "../utils/map_utils";

class StitchPreRound0Disagreementv2 extends BaseLayer {

    id = "stitchPreRound0Disagreementv2";
    label = "Before";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchPreR0Disagreement, textColor} = this.props;
        plotDisagreementsHelper(stitchPreR0Disagreement.result, this.props.slide, this.layer.getSource(), textColor);
        resolve();
    });
}

export default StitchPreRound0Disagreementv2;
